import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const CallToActionLFC = lazy(() => import('.'))

class CallToActionLFCComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<CallToActionLFC />
			</RootProviders>
		)
	}
}

customElements.define('editor-call-to-action-banner-lfc', CallToActionLFCComponent)
